import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutModule } from './layout/layout/layout.module';
import { MaterialModule } from './material.module';

import { CereriModule } from './components/cereri/cereri.module';

import { HttpClientModule } from '@angular/common/http';
import { httpInterceptorProviders } from './interceptors';
import { AdminSetariModule } from './platform/nomenclatoare/administrativ/admin-setari/admin-setari.module';
import { SettingsModule } from './components/settings/settings.module';
import { TokenGuard } from './guards/token.guard';
import { TokenComponent } from './components/token/token.component';

import { ToastrModule } from 'ngx-toastr';
import { RegistruModule } from './components/registru/registru.module';
import { SlugPageComponent } from './components/slugPage/slug-page.component';
import { ConfirmareDocumenteModule } from './components/confirmare-documente/confirmare-documente.module';

@NgModule({
    declarations: [AppComponent, TokenComponent, SlugPageComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        LayoutModule,
        MaterialModule,
        SettingsModule,
        CereriModule,
        RegistruModule,
        ConfirmareDocumenteModule,
        HttpClientModule,
        AdminSetariModule,
        ToastrModule.forRoot(),
    ],
    providers: [httpInterceptorProviders, TokenGuard],
    bootstrap: [AppComponent],
})
export class AppModule { }
